export default "__VITE_ASSET__CHGBbJ59__"